import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
const IcoMastercard16 = t0 => {
  const $ = _c(5);
  const {
    "aria-label": ariaLabel,
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <g><path d="M10.1634 4.05688H5.83691V11.8317H10.1634V4.05688Z" fill="#FF5F00" /><path d="M6.11158 7.94452C6.1109 7.19576 6.28057 6.45665 6.60776 5.78316C6.93495 5.10966 7.41108 4.51942 8.0001 4.05714C7.27068 3.4838 6.39467 3.12725 5.47219 3.02824C4.54971 2.92923 3.61799 3.09176 2.78352 3.49724C1.94904 3.90273 1.24548 4.53481 0.753254 5.32125C0.26103 6.10769 0 7.01675 0 7.94452C0 8.8723 0.26103 9.78136 0.753254 10.5678C1.24548 11.3542 1.94904 11.9863 2.78352 12.3918C3.61799 12.7973 4.54971 12.9598 5.47219 12.8608C6.39467 12.7618 7.27068 12.4052 8.0001 11.8319C7.41108 11.3696 6.93496 10.7794 6.60777 10.1059C6.28058 9.4324 6.1109 8.69329 6.11158 7.94452Z" fill="#EB001B" /><path d="M15.9998 7.94452C15.9999 8.87228 15.7389 9.78134 15.2467 10.5678C14.7545 11.3542 14.051 11.9863 13.2165 12.3918C12.382 12.7973 11.4503 12.9598 10.5279 12.8608C9.6054 12.7618 8.7294 12.4052 8 11.8319C8.5885 11.3692 9.06426 10.7788 9.39139 10.1054C9.71853 9.43205 9.8885 8.69317 9.8885 7.94452C9.8885 7.19587 9.71853 6.457 9.39139 5.78361C9.06426 5.11022 8.5885 4.51989 8 4.05714C8.7294 3.4838 9.6054 3.12725 10.5279 3.02824C11.4503 2.92923 12.382 3.09176 13.2165 3.49725C14.051 3.90274 14.7545 4.53483 15.2467 5.32127C15.7389 6.1077 15.9999 7.01676 15.9998 7.94452Z" fill="#F79E1B" /><path d="M15.5285 11.0083V10.8491H15.5927V10.8167H15.4292V10.8491H15.4934V11.0083H15.5285ZM15.8458 11.0083V10.8163H15.7957L15.7381 10.9484L15.6804 10.8163H15.6303V11.0083H15.6657V10.8635L15.7197 10.9883H15.7564L15.8105 10.8632V11.0083H15.8458Z" fill="#F79E1B" /></g>;
    t2 = <defs />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== ariaLabel || $[3] !== className) {
    t3 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={true}>{t1}{t2}</svg>;
    $[2] = ariaLabel;
    $[3] = className;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default IcoMastercard16;